export default __webpack_public_path__ + "static/media/161.1a21e939.png";